<div class="input-wrapper">
  <lib-reactive-form-group
    #searchForm
    [bindTo]="searchForm$ | async"
    [applyDisabledStylesToAllElements]="true"
    [includeIconWithError]="true"
    (formSubmitted$)="formSubmitted($event)">
    <lib-reactive-form-text
      *ngIf="!numbersOnly"
      [disabled]="disabled"
      [inputName]="(bindingProperty$ | async) ?? ''"
      [bindingProperty]="(bindingProperty$ | async) ?? ''"
      [placeholder]="(placeholder$ | async) ?? ''"
      (valueChanged)="searchForm.submitForm()" />
    <lib-reactive-form-number
      *ngIf="numbersOnly"
      [disabled]="disabled"
      [inputName]="(bindingProperty$ | async) ?? ''"
      [bindingProperty]="(bindingProperty$ | async) ?? ''"
      [placeholder]="(placeholder$ | async) ?? ''"
      (valueChanged)="searchForm.submitForm()" />
  </lib-reactive-form-group>
  <div class="mobile-overlay" (click)="onMobileInputClick()"></div>
</div>
